import React from "react";
import Chip from "@mui/material/Chip";

const Skills = () => { // TODO: Add skills
  const skillCategories = {
    "Languages & Frameworks": [
      "JavaScript",
      "React",
      "Python",
      "Java",
      "SQL",
      "Unity3D",
      "TypeScript",
    ],
    "Tools & Platforms": [
      "APIs & Integration",
      "Cloud Computing",
      "Git",
      "Docker",
      "AWS",
    ],
    "Specializations": [
      "Integration Architecture",
      "Web Development",
      "Game Development",
      "Music Production",
    ],
  };

  return (
    <div className="skills-section">
      <div className="title">
        <h2 className="heading">my toolkit.</h2>
        <p className="section-subtitle">Stuff I'm pretty good at</p>
      </div>
      <div className="skills-container">
        {Object.entries(skillCategories).map(([category, skills]) => (
          <div key={category} className="skill-category">
            <h3>{category}</h3>
            <div className="skills-chips">
              {skills.map((skill) => (
                <Chip
                  key={skill}
                  label={skill}
                  variant="outlined"
                  className="skill-chip"
                  sx={{
                    borderColor: "var(--primary-color2)",
                    color: "var(--accent-color1)",
                    m: 0.5,
                    "&:hover": {
                      backgroundColor: "rgba(191, 99, 48, 0.1)",
                    },
                  }}
                />
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Skills;
